export const environment = {
    production: true,
    authApiUrl: 'https://internal-auth-qa.townsq.io',
    loginPath: '/auth/login',
    postLoginPath: '/dashboard',
    authSuccessPath: '/auth/success',
    authErrorPath: '/auth/unauthorized',
    secureUrls: ['https://internal-auth-qa.townsq.io', 'https://r3tuo35dm9.execute-api.us-west-2.amazonaws.com'],
    bffApiUrl: 'https://r3tuo35dm9.execute-api.us-west-2.amazonaws.com'
};
